import { getModifiers } from '@helpers/functions';
import Button from '@atoms/buttons/Button';
import { LazyLoadMoreModel } from '@_types/types';
import RequireJs from '@helpers/RequireJs';

const LazyLoadMore = (model: LazyLoadMoreModel) => {
  const styleModifier = getModifiers(model, 'kf-m-lazy-load-more');
  const { lazyLoadMoreSourceId, currentPage, label, total, offset, loadMoreButton, pageSize, sourceEndpoint, searchId, excludeJs, searchPageId } =
    model;

  return (
    <div
      className={`${styleModifier} kf-container`}
      data-current-page={currentPage}
      data-offset={offset}
      data-page-size-desktop={pageSize?.desktop}
      data-page-size-mobile={pageSize?.mobile}
      data-page-size-tablet={pageSize?.tablet}
      data-search-id={searchId}
      data-search-page-id={searchPageId}
      data-source-endpoint={sourceEndpoint}
      data-source-id={lazyLoadMoreSourceId}
      data-total={total}
    >
      <p className="kf-m-lazy-load-more__label">{label}</p>

      <progress aria-label="load-more-progress" className="kf-m-lazy-load-more__progress-bar" max={total} value={offset} />

      {loadMoreButton && <Button {...loadMoreButton} />}

      {!excludeJs && <RequireJs defer path={'lazy-load-more'} />}
    </div>
  );
};

export default LazyLoadMore;
